import { render, staticRenderFns } from "./SectionPodcasts.vue?vue&type=template&id=176e0c6a&scoped=true"
import script from "./SectionPodcasts.vue?vue&type=script&lang=js"
export * from "./SectionPodcasts.vue?vue&type=script&lang=js"
import style0 from "./SectionPodcasts.vue?vue&type=style&index=0&id=176e0c6a&prod&lang=scss"
import style1 from "./SectionPodcasts.vue?vue&type=style&index=1&id=176e0c6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176e0c6a",
  null
  
)

export default component.exports